import { render } from "./YPRegistration.vue?vue&type=template&id=52126bc1&scoped=true"
import script from "./YPRegistration.vue?vue&type=script&lang=js"
export * from "./YPRegistration.vue?vue&type=script&lang=js"

import "./YPRegistration.vue?vue&type=style&index=0&id=52126bc1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52126bc1"]])

export default __exports__